import { render } from "./ContextComparisonCard.vue?vue&type=template&id=c74a9514&scoped=true"
import script from "./ContextComparisonCard.vue?vue&type=script&lang=js"
export * from "./ContextComparisonCard.vue?vue&type=script&lang=js"

import "./ContextComparisonCard.vue?vue&type=style&index=0&id=c74a9514&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c74a9514"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QInnerLoading});
